$(function () {
    $(document).on('keypress', '.js-click-on-enter', function (e) {
        if (e.which == 13) {
            e.preventDefault();
            $(this).click();
        }
    });

    $(document).on('keypress', '.js-click-on-space', function (e) {
        if (e.which == 32) {
            e.preventDefault();
            $(this).click();
        }
    });

    $(document).on('keypress', '.js-click-on-enter-or-space', function (e) {
        if (e.which == 13 || e.which == 32) {
            e.preventDefault();
            $(this).click();
        }
    });

    $(document).on('keypress', '.js-click-first-child-on-enter', function (e) {
        if (e.which == 13) {
            e.preventDefault();
            $(this).children().first().click();
        }
    });

    $(document).on('keypress', '.js-click-first-child-on-space', function (e) {
        if (e.which == 32) {
            e.preventDefault();
            $(this).children().first().click();
        }
    });
});
